import { RadioGroup as RadioGroupPrimitive } from '@base-ui/react/radio-group';

import { cn } from '@/lib/utils';

export type RadioGroupProps = RadioGroupPrimitive.Props & {
  orientation?: 'vertical' | 'horizontal';
};

const RadioGroup = ({ className, orientation = 'vertical', ...props }: RadioGroupProps) => {
  return (
    <RadioGroupPrimitive
      data-slot="radio-group"
      className={cn('grid gap-2', { 'grid-flow-col': orientation === 'horizontal' }, className)}
      {...props}
    />
  );
};

export default RadioGroup;
